export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    bell_01: [
      0,
      1635.5555555555557,
    ],
    big_win: [
      3000,
      4067.8458049886626,
    ],
    button_spin: [
      9000,
      973.786848072562,
    ],
    end_free_spin: [
      11000,
      4241.995464852607,
    ],
    free_bet_big_win: [
      17000,
      1377.2335600907013,
    ],
    free_bet_mega_win: [
      20000,
      2213.151927437643,
    ],
    free_bet_total_win: [
      24000,
      979.591836734695,
    ],
    free_bet_ultra_win: [
      26000,
      1319.1836734693893,
    ],
    free_spin_ambient: [
      29000,
      35155.01133786848,
    ],
    free_spin_music: [
      66000,
      32000,
    ],
    free_spin_popup: [
      99000,
      3110.022675736957,
    ],
    free_spin_start: [
      104000,
      3731.1564625850338,
    ],
    inside_buttons: [
      109000,
      451.3378684807208,
    ],
    main_ambient: [
      111000,
      76727.43764172336,
    ],
    main_music: [
      189000,
      178040.45351473923,
    ],
    mega_win: [
      369000,
      4358.095238095246,
    ],
    outside_buttons: [
      375000,
      593.5600907029652,
    ],
    reel_spin: [
      377000,
      2589.024943310676,
    ],
    reel_stop_01: [
      381000,
      226.39455782314144,
    ],
    reel_stop_02: [
      383000,
      317.82312925167844,
    ],
    reel_stop_03: [
      385000,
      320.7256235827458,
    ],
    reel_stop_04: [
      387000,
      341.0430839002174,
    ],
    reel_stop_05: [
      389000,
      323.6281179138132,
    ],
    regular_win: [
      391000,
      1681.995464852605,
    ],
    scatter_stop: [
      394000,
      1423.6734693877793,
    ],
    tap_to_play: [
      397000,
      5609.070294784601,
    ],
    ultra_win: [
      404000,
      5980.589569160998,
    ],
    wild_stop: [
      411000,
      1185.6689342403683,
    ],
  },
}
